import { Component, OnInit } from '@angular/core';
import { LocationService, TutionLocation } from '../location.service';


@Component({
    selector: 'app-locations',
    templateUrl: './locations.component.html',
    styleUrls: ['./locations.component.css'],
    standalone: false
})
export class LocationsComponent implements OnInit {

  allLocations: TutionLocation[] = [];
  filteredLocations: TutionLocation[] = [];
  activeFilter: string = 'all';
  searchTerm: string = '';
  sortBy: string = 'distance';


  constructor(private locationService: LocationService) { }

  ngOnInit() {
    this.allLocations = this.locationService.getAllLocations();
    this.filteredLocations = [...this.allLocations];
  }

  onSearch(event: any) {
    this.searchTerm = event.target.value;
    this.applyFilters();
  }

  onFilterChange(filter: string) {
    this.activeFilter = filter;
    this.applyFilters();
  }

  onSortChange(event: any) {
    this.sortBy = event.target.value;
    this.sortLocations();
  }

  applyFilters() {
    let results = this.locationService.searchLocations(this.searchTerm);
    
    if (this.activeFilter !== 'all') {
      results = results.filter(loc => 
        loc.services.some(s => s.toLowerCase().includes(this.activeFilter.toLowerCase()))
      );
    }
    
    this.filteredLocations = results;
    this.sortLocations();
  }

  sortLocations() {
    switch(this.sortBy) {
      case 'name-az':
        this.filteredLocations.sort((a, b) => a.town.localeCompare(b.town));
        break;
      case 'name-za':
        this.filteredLocations.sort((a, b) => b.town.localeCompare(a.town));
        break;
      case 'distance':
      default:
        this.filteredLocations.sort((a, b) => (a.distance || 0) - (b.distance || 0));
        break;
    }
  }

  get resultsCount(): number {
    return this.filteredLocations.length;
  }
}
